import React from "react";
import { object, shape, string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { FluidCollapsibleComponent } from "./FluidCollapsibleComponent";

const FluidCollapsibleComponentConnector = ({ data, locale }) => (
	<FluidCollapsibleComponent
		sectionHeading={data.sectionHeading}
		buttonText={data.buttonText}
		fluidContentSections={data.fluidContentSections}
		locale={locale}
	/>
);

FluidCollapsibleComponentConnector.propTypes = {
	data: shape({
		sectionHeading: string,
		buttonText: string.isRequired,
		fluidContentSections: object,
	}),
	locale: string,
};
FluidCollapsibleComponentConnector.defaultProps = {
	data: null,
	locale: null,
};

export default FluidCollapsibleComponentConnector;
export { FluidCollapsibleComponentConnector };
